<script lang="ts">
    import {getInjector} from 'src/core';
    import {AttendanceCalendarService} from 'src/features/erp-sutor/features/attendance-calendar';
    import type {GridField} from 'src/features/record-grid/lib/types';
    import type {DateTime} from 'luxon';
    import {onMount} from 'svelte';
    import {getDateFromGridFieldValue} from 'src/features/erp-sutor/sutor-utils';
    import {exists} from 'shared/utils/custom-utils';
    import {tooltip} from 'shared/ui-widgets/tooltip/use.tooltip';
    import {hasOriginRecordReference} from 'src/features/record-grid/lib/types-utils';
    import {
        formatDurationStringToHours,
        sumDurationStrings
    } from 'src/features/erp-sutor/features/attendance-calendar/utils';
    import KpLoadingBlock from 'shared/components/kp-loading/KpLoadingBlock.svelte';

    export let dateField: GridField;
    export let workerField: GridField;

    const attendanceService = getInjector().getByClass(AttendanceCalendarService);

    interface DayPwkAttendance {
        work: string;
        overtime: string;
        absence: string;
    }

    let loadingPowerKey = true;
    let powerKeyDaySum: DayPwkAttendance | null = null;

    onMount(async () => {
        const date = getDateFromGridFieldValue(dateField);
        if (!exists(date)) {
            loadingPowerKey = false;
            return;
        }

        powerKeyDaySum = await loadPowerKeyDaySum(date);
        loadingPowerKey = false;
    });

    async function loadPowerKeyDaySum(date: DateTime): Promise<DayPwkAttendance | null> {
        if (!exists(workerField) || !hasOriginRecordReference(workerField)) {
            return null;
        }

        const dayAttendance = await attendanceService.getWorkAttendanceDays(workerField.originRecordReference.id, date.toJSDate(), date.plus({days: 1}).toJSDate());
        const attendance = dayAttendance[0];
        if (!exists(attendance)) {
            return null;
        }

        return {
            work: attendance.attendanceSourceRegularWork.duration,
            overtime: attendance.attendanceSourceOvertimeWork.duration,
            absence: attendance.attendanceSourceAbsence.duration
        };
    }
</script>

{#if loadingPowerKey}
    <KpLoadingBlock size="xs"/>
{:else if exists(powerKeyDaySum)}
    <span use:tooltip={'Práce + Přesčas + Absence'}>
        {formatDurationStringToHours(sumDurationStrings(powerKeyDaySum.work, powerKeyDaySum.overtime, powerKeyDaySum.absence))}
    </span>
{:else}
    <span class="no-powerkey-data">N/A</span>
{/if}

<style>
    .no-powerkey-data {
        color: var(--danger-red);
    }
</style>